import Vue from 'vue'
import VueRouter from 'vue-router'

import AdminLayout from '@/layout/adminLayout'

const ResourceSettingPage = () => import(/* webpackChunkName: "ResourceSettingPage" */ '@/views/admin/resource/setting/index.vue')
const ResourceDetailPage = () => import(/* webpackChunkName: "ResourceDetailPage" */ '@/views/admin/resource/detail/index.vue')
const ResourceDispenseflowPage = () => import(/* webpackChunkName: "ResourceDispenseflowPage" */ '@/views/admin/resource/dispenseflow/index.vue')
const VoucherIncomePage = () => import(/* webpackChunkName: "VoucherIncomePage" */ '@/views/admin/income/voucherIncome/index.vue')
const ShareIncomePage = () => import(/* webpackChunkName: "ShareIncomePage" */ '@/views/admin/income/shareIncome/index.vue')
const IncomeSummaryPage = () => import(/* webpackChunkName: "IncomeSummaryPage" */ '@/views/admin/income/summary/index.vue')
const BaseBasePage = () => import(/* webpackChunkName: "BaseBasePage" */ '@/views/admin/baseinfo/base/index.vue')
const BaseProductPage = () => import(/* webpackChunkName: "BaseProductPage" */ '@/views/admin/baseinfo/product/index.vue')
const BaseUserPage = () => import(/* webpackChunkName: "BaseUserPage" */ '@/views/admin/baseinfo/user/index.vue')
const EmpowerAnalysisPage = () => import(/* webpackChunkName: "EmpowerAnalysisPage" */ '@/views/admin/statistics/empowerAnalysis/index.vue')
const IncomeAnalysisPage = () => import(/* webpackChunkName: "IncomeAnalysisPage" */ '@/views/admin/statistics/incomeAnalysis/index.vue')
const DetailSettingPage = () => import(/* webpackChunkName: "IncomeAnalysisPage" */ '@/views/admin/resource/setting/detailSetting/DetailSetting.vue')
Vue.use(VueRouter)

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}

const routes = [
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      {
        path: '/',
        redirect: '/admin/resource/setting'
      },
      {
        path: 'resource',
        meta: {
          // someApis: ['@common/LOGOUT'],
          title: '资源管理'
        },
        component: RouteView,
        children: [
          {
            path: '/',
            redirect: '/admin/resource/setting'
          },
          {
            path: '/admin/resource/setting/detailSetting',
            name: 'DetailSettingPage',
            component: DetailSettingPage
          },
          {
            path: 'setting',
            name: 'ResourceSetting',
            component: ResourceSettingPage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              title: '资源配置'
            }
          },
          {
            path: 'detail',
            name: 'detail',
            component: ResourceDetailPage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              // apis: ['@common/LOGOUT'],
              title: '资源发放详情'
            }
          },
          {
            path: 'dispenseflow',
            name: 'dispenseflow',
            component: ResourceDispenseflowPage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              // apis: ['@common/LOGOUT'],
              title: '发放与流水'
            }
          }
        ]
      },
      {
        path: 'income',
        meta: {
          // someApis: ['@common/LOGOUT'],
          title: '收入管理'
        },
        component: RouteView,
        children: [
          {
            path: '/',
            redirect: '/admin/income/voucherIncome'
          },
          {
            path: 'voucherIncome',
            name: 'voucherIncome',
            component: VoucherIncomePage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              // apis: ['@common/LOGOUT'],
              title: '券类收入'
            }
          },
          {
            path: 'shareIncome',
            name: 'shareIncome',
            component: ShareIncomePage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              // apis: ['@common/LOGOUT'],
              title: '均摊收入'
            }
          },
          {
            path: 'summary',
            name: 'summary',
            component: IncomeSummaryPage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              // apis: ['@common/LOGOUT'],
              title: '收入汇总'
            }
          }
        ]
      },
      {
        path: 'statistics',
        meta: {
          // someApis: ['@common/LOGOUT'],
          title: '数据统计'
        },
        component: RouteView,
        children: [
          {
            path: '/',
            redirect: '/admin/statistics/empowerAnalysis'
          },
          {
            path: 'empowerAnalysis',
            name: 'empowerAnalysis',
            component: EmpowerAnalysisPage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              // apis: ['@common/LOGOUT'],
              title: '赋能分析'
            }
          },
          {
            path: 'incomeAnalysis',
            name: 'incomeAnalysis',
            component: IncomeAnalysisPage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              // apis: ['@common/LOGOUT'],
              title: '收入分析'
            }
          }]
      },
      {
        path: 'baseinfo',
        meta: {
          // someApis: ['@common/LOGOUT'],
          title: '基础信息管理'
        },
        component: RouteView,
        children: [
          {
            path: '/',
            redirect: '/admin/baseinfo/base'
          },
          {
            path: 'base',
            name: 'base',
            component: BaseBasePage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              // apis: ['@common/LOGOUT'],
              title: '基地管理'
            }
          },
          {
            path: 'product',
            name: 'product',
            component: BaseProductPage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              apis: ['@productManage/Query_Products'],
              title: '产品管理'
            }
          },
          {
            path: 'user',
            name: 'user',
            component: BaseUserPage,
            meta: {
              // someApis: ['@common/LOGOUT'],
              apis: ['@userManage/Query_Users'],
              title: '用户管理'
            }
          }
        ]
      },
      {
        path: '403',
        name: '403',
        component: () => import(/* webpackChunkName: "403" */ '@/views/common/403/index.vue')
      },
      {
        path: '404',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/views/common/404/index.vue')
      },
      {
        path: '*', // 此处需特别注意至于最底部
        redirect: '404'
      }
    ]
  },
  {
    path: '/403',
    name: '403',
    component: () => import(/* webpackChunkName: "403" */ '@/views/common/403/index.vue')
  },
  {
    path: '/',
    redirect: '/admin'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

export default router
